import { createContext } from 'react'
import { RootState } from 'typesafe-actions'

type TAsetukset = RootState['asetukset']

const AsetuksetContext = createContext<TAsetukset>(new Map())

export default AsetuksetContext
